module.exports = "<h2 class=\"gw-titles-heading\">\r\n    <ng-transclude></ng-transclude>\r\n</h2>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/titles/templates/Heading.html
// module id = 605
// module chunks = 0